<template>
  <div class="modal-wrap">
    <div class="content-wrap">
      <span class="material-icons" @click="$emit('close-modal')"> close </span>
      <h1>Specify the type of content</h1>
      <div class="select-wrap">
        <select v-model="contentTypeId">
          <option selected disabled :value="null">Select Type</option>
          <option
            v-for="contentType in contentTypes"
            :key="contentType.cnt_id"
            :value="contentType.cnt_id"
          >
            {{ contentType.cnt_name }}
          </option>
        </select>
        <select v-model="contentGroupId">
          <option selected disabled :value="null">Select Group</option>
          <option :value="''">None</option>
          <option
            v-for="contentGroup in contentGroups"
            :key="contentGroup.ctg_id"
            :value="contentGroup.ctg_id"
          >
            {{ contentGroup.ctg_name }}
          </option>
        </select>
      </div>
      <div class="form-wrap" v-if="contentTypeId">
        <div class="groupname-wrap" v-if="contentGroupId">
          <label for="groupName">Content Group Name:</label>
          <input
            type="text"
            id="groupName"
            v-model.trim="groupName"
            :class="groupNameError ? 'has-error' : ''"
          />
        </div>
        <div
          class="file-wrap"
          v-if="selectedTypeIncludes(['image', 'pdf', 'logo'])"
        >
          <p>{{ `Upload document` }}</p>
          <label for="file" class="file-label">Choose a file</label>
          {{ file ? file.name : "" }}
          <input type="file" id="file" @change="getFile" />
          <button @click="prepareParamsAndEmitContent('con_data', file)">
            Edit Content
          </button>
        </div>
        <div
          class="text-wrap"
          v-if="
            selectedTypeIncludes([
              'video',
              'audio',
              'link',
              'external',
              'screen',
              'bbb_external',
              'bbb_modal',
            ])
          "
        >
          <label for="text"
            >Set a
            {{
              selectedTypeIncludes(["bbb_external", "bbb_modal"])
                ? "param"
                : "link"
            }}
            {{
              selectedTypeIncludes(["video", "screen"])
                ? "(Must be embedded link)"
                : ""
            }}</label
          >
          <input type="text" id="text" v-model.trim="link" />
          <button @click="prepareParamsAndEmitContent('con_text', link)">
            Edit Content
          </button>
        </div>
        <div class="text-wrap" v-if="selectedTypeIncludes(['tooltip'])">
          <label for="text">Set tooltip text</label>
          <textarea id="html" v-model.trim="text"></textarea><br />
          <button @click="prepareParamsAndEmitContent('con_text', text)">
            Edit Content
          </button>
        </div>
        <div
          class="html-wrap"
          v-if="selectedTypeIncludes(['html', 'html-modal'])"
        >
          <label for="html">Write HTML</label>
          <div
            class="transparent-wrap"
            v-if="selectedTypeIncludes(['html-modal'])"
          >
            <input
              id="isTransparent"
              type="checkbox"
              :value="isTransparent"
              @change="isTransparent = !isTransparent"
            />
            <label for="isTransparent">Transparent background</label>
          </div>
          <br />
          <textarea class="resize" id="html" v-model.trim="html"></textarea
          ><br />
          <button @click="prepareParamsAndEmitContent('con_data', html)">
            Edit Content
          </button>
        </div>
        <div class="slido-wrap" v-if="selectedTypeIncludes(['slido'])">
          <label for="html">Paste iframe</label><br />
          <textarea id="html" v-model.trim="slido"></textarea><br />
          <button @click="prepareParamsAndEmitContent('con_text', slido)">
            Edit Content
          </button>
        </div>
        <div class="chat-wrap" v-if="selectedTypeIncludes(['chat'])">
          <label>Add chat admin: </label>
          <select v-model="userId">
            <option
              v-for="user in users"
              :value="user.usr_id"
              :key="user.usr_id"
            >
              {{ user.usr_firstname + " " + user.usr_lastname }}
            </option>
          </select>
          <button @click="prepareParamsAndEmitContent('con_text', userId)">
            Edit content
          </button>
        </div>
        <div
          class="none-wrap"
          v-if="
            selectedTypeIncludes([
              'support',
              'back',
              'public',
              'likes',
              'booth-chat',
            ])
          "
        >
          <button @click="prepareParamsAndEmitContent('con_text', null)">
            Edit content
          </button>
        </div>
        <div class="internal-wrap" v-if="selectedTypeIncludes(['internal'])">
          <label v-if="content && !content.softSaveId"
            >Current link: "{{ content.con_text }}"</label
          >
          <label
            >Choose a {{ content && !content.softSaveId ? "new" : "" }} link
            to:</label
          >
          <select v-model="selectedLocId">
            <option
              v-for="location in locations"
              :key="location.loc_id"
              :value="location.loc_id"
            >
              {{ location.name }}
            </option>
          </select>
          <div class="skip-wrap">
            <label for="skip">Skip video:</label>
            <input type="checkbox" id="skip" v-model="skip" />
          </div>
          <button
            @click="prepareParamsAndEmitContent('con_text', selectedLocId)"
          >
            Edit content
          </button>
        </div>
        <div
          class="contact-wrap"
          v-if="selectedTypeIncludes(['contact', 'subscribe', 'request_meet'])"
        >
          <div class="input-wrap">
            <label for="contact-email">Contact email:</label>
            <input id="contact-email" v-model.trim="contactEmail" />
          </div>
          <button
            @click="prepareParamsAndEmitContent('con_text', contactEmail)"
          >
            Edit content
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    coords: Object,
    content: null,
    location: Object,
  },
  data() {
    return {
      isTransparent: false,

      groupName: "",
      groupNameError: false,

      users: [],
      userId: "",

      contentGroups: [],
      contentGroupId: null,

      contentTypes: [],
      contentTypeId: null,

      file: null,

      link: "",
      text: "",
      html: "",
      skip: null,
      slido: "",
      contactEmail: "",

      locations: [],
      selectedLocId: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.startLoading();
      this.contentGroups = await this.get(api.getContentGroups);
      this.contentTypes = await this.setContentTypes();
      const tempUsers = await this.get(api.getUsers, {
        limit: 10000,
        offset: 0,
      });
      const tempLocations = await this.get(api.getAgendaLocations);
      this.locations = tempLocations.filter((location) => {
        if (this.isLocationLinkable(location)) {
          return location;
        }
      });
      this.users = tempUsers.filter((el) => !el.usr_deleted);
      if (this.content) this.mapExistingContentToDataParams();
      this.stopLoading();
    },
    async setContentTypes() {
      // booth chat clickable element is only available for booth content
      const types = await this.get(api.getContentTypes);
      if (this.location.ltp_code !== "bth") {
        const boothChatIndex = types.findIndex(
          (type) => type.cnt_code === "bch"
        );
        types.splice(boothChatIndex, 1);
      }
      return types;
    },
    isLocationLinkable(location) {
      return (
        location.ltp_code === "intr" ||
        location.ltp_code === "info" ||
        location.ltp_code === "conf" ||
        location.ltp_code === "intl" ||
        location.ltp_code === "bth"
      );
    },
    mapExistingContentToDataParams() {
      this.isTransparent = this.content.isTransparent || false;
      this.groupName = this.content.con_groups ? this.content.con_groups : "";
      this.contentGroupId = this.content.ctg_id ? this.content.ctg_id : null;
      this.contentTypeId = this.content.cnt_id;
      this.mapConTextToProperDataParam();
    },
    mapConTextToProperDataParam() {
      if (
        this.selectedTypeIncludes([
          "video",
          "audio",
          "link",
          "external",
          "screen",
          "bbb_external",
          "bbb_modal",
        ])
      ) {
        this.link = this.content.con_text;
      }
      if (this.selectedTypeIncludes(["tooltip"])) {
        this.text = this.content.con_text;
      }
      if (this.selectedTypeIncludes(["internal"])) {
        this.selectedLocId = this.extractLocId();
        if (this.content.skip !== undefined) {
          this.skip = this.content.skip;
        } else if (this.content.con_text.indexOf("skip=true") !== -1) {
          this.skip = true;
        }
      }
      if (this.selectedTypeIncludes(["chat"]))
        this.userId = this.content.con_text;
      if (this.selectedTypeIncludes(["html", "html-modal"]))
        this.html = this.tryParseBinary();
      if (this.selectedTypeIncludes(["slido"]))
        this.slido = this.content.con_text;
      if (this.selectedTypeIncludes(["image", "pdf", "logo"]))
        this.file = this.content.con_data;
      if (this.selectedTypeIncludes(["contact", "subscribe", "request_meet"]))
        this.contactEmail = this.content.con_text;
    },
    extractLocId() {
      if (this.content.softSaveId || this.content.con_id) {
        return this.content.con_text;
      } else {
        let conTextParts = this.content.con_text.split("/");
        return conTextParts[conTextParts.length - 1];
      }
    },
    tryParseBinary() {
      try {
        return this.b64DecodeUnicode(this.content.con_data);
      } catch (error) {
        return this.content.con_data;
      }
    },
    b64DecodeUnicode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(
        atob(str)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    },
    async get(api, params) {
      let apiObj = {
        api: api,
        params: params ? params : "",
        onError: () => this.stopLoading(),
      };

      const data = await this.apiCall(apiObj);
      if (data) {
        return data.result;
      }
    },
    getFile(e) {
      this.file = e.target.files[0];
    },
    getRandomLetters(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    async prepareParamsAndEmitContent(key, value) {
      let validated_ctg_id =
        this.contentGroupId == "" ? null : this.contentGroupId;

      let params = {
        con_groups: this.groupName,
        cnt_id: this.contentTypeId,
        ctg_id: validated_ctg_id,
        top: this.coords.top,
        bottom: this.coords.bottom,
        left: this.coords.left,
        right: this.coords.right,
        isTransparent: this.isTransparent,
        css_class: this.getRandomLetters(7),
      };

      if (this.selectedTypeIncludes(["internal"])) {
        params.skip = this.skip;
      }

      params[key] = value;

      if (this.content) {
        params.con_id = this.content.con_id;
        params.clm_id = this.content.clm_id;
        if (this.content.softSaveId !== undefined) {
          params.softSaveId = this.content.softSaveId;
        }
      }
      this.emitContent(params);
    },
    async emitContent(params) {
      if (this.hasErrors()) {
        return;
      }
      this.startLoading();
      this.EventBus.$emit("info", {
        message: "Content isn't saved yet. After all editing, confirm changes.",
      });
      this.$emit("soft-save-content", params);
      this.$emit("close-modal");
      this.stopLoading();
    },
    hasErrors() {
      this.resetErrors();
      if (
        this.selectedTypeIncludes([
          "video",
          "audio",
          "link",
          "external",
          "screen",
          "bbb_external",
          "bbb_modal",
        ])
      ) {
        if (this.link.length > 254) {
          this.handleError(new Error("Please use a shorter link."));
          return true;
        }

        if (this.link.length === 0) {
          this.handleError(new Error("Link can't be empty."));
          return true;
        }
      }

      if (this.selectedTypeIncludes(["tooltip"])) {
        if (this.text.length === 0) {
          this.handleError(new Error("Text can't be empty."));
          return true;
        }
      }

      if (this.selectedTypeIncludes(["contact", "subscribe", "request_meet"])) {
        if (this.contactEmail.length > 254) {
          this.handleError(new Error("Please use a shorter email."));
          return true;
        }

        if (this.contactEmail.length === 0) {
          this.handleError(new Error("Email can't be empty."));
          return true;
        }

        const isEmailValid = /^(\w+.?)+@(\w+.?)+.\w+$/.test(this.contactEmail);
        if (!isEmailValid) {
          this.handleError(new Error("Please enter a valid email."));
          return true;
        }
      }

      if (this.contentGroupId) {
        if (!this.groupName) {
          this.handleError(
            new Error(
              "This content is grouped. You should specify a name for it."
            )
          );
          this.groupNameError = true;
          return true;
        }
      }

      if (!this.userId && this.selectedTypeIncludes(["chat"])) {
        this.handleError(new Error("Please choose a user."));
        return true;
      }

      if (
        typeof this.selectedLocId === "string" &&
        this.selectedTypeIncludes(["internal"])
      ) {
        this.handleError(new Error("Please choose a location."));
        return true;
      }

      if (!this.file && this.selectedTypeIncludes(["image", "pdf", "logo"])) {
        this.handleError(new Error("Please choose a file."));
        return true;
      }

      return false;
    },
    resetErrors() {
      this.groupNameError = false;
    },
    selectedTypeIncludes(conditionsArray) {
      let contentType;

      for (let i = 0; i < this.contentTypes.length; i++) {
        if (this.contentTypes[i].cnt_id === this.contentTypeId) {
          contentType = this.contentTypes[i];
        }
      }

      for (let j = 0; j < conditionsArray.length; j++) {
        conditionsArray[j] = conditionsArray[j].toLowerCase();
      }

      if (
        contentType &&
        conditionsArray.includes(contentType.cnt_name.toLowerCase())
      ) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    console.log(this.location);
  },
};
</script>

<style scoped lang='scss'>
* {
  box-sizing: border-box;
}
.modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  padding: 0;
  margin: 0;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 21;
}
.content-wrap {
  position: relative;
  padding: 20px;
  min-width: 40%;
  max-width: 40%;
  min-height: 40vh;
  background: #fff;
  border-radius: 20px;
}
.material-icons {
  position: absolute;
  top: 4px;
  right: 12px;
  cursor: pointer;
}
.select-wrap {
  margin: 20px 0;
}
.select-wrap select {
  margin-right: 25px;
  border-radius: 20px;
  padding: 5px;
  background: #fff;
  outline: none;
}
.select-wrap select.has-error,
.has-error {
  border: 2px solid red;
}

.add-class-input {
  width: 30%;
  display: inline;
}
textarea {
  &.resize {
    resize: vertical;
  }
  resize: none;
  width: 100%;
  height: 15vh;
}
.file-wrap,
.text-wrap,
.html-wrap,
.slido-wrap,
.chat-wrap,
.none-wrap,
.internal-wrap,
.contact-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin: 20px 0;
  gap: 5px 0;
}
.skip-wrap {
  display: flex;
  gap: 0 5px;
  align-items: center;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
.file-wrap button,
.text-wrap button,
.html-wrap button,
.slido-wrap button,
.chat-wrap button,
.none-wrap button,
.internal-wrap button,
.contact-wrap button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  padding: 8px 23px;
  border-radius: 100px;
  font-size: 13px;
  outline: none;
  background: var(--button-color-blue);
  color: white;
  width: 30%;
  margin: 20px auto;
}
.transparent-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
}
input[type="file"] {
  display: none;
}
.file-label {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 2% 4%;
  font-size: 1em;
  box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 13px;
  background: #f68d22;
  color: white;
}
.users-badges {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 0;
  width: 100%;
}
.user-badge {
  margin: 5px 0;
  margin-right: 10px;
  white-space: nowrap;
  border: none;
  padding: 8px 43px 8px 23px;
  border-radius: 100px;
  font-size: 13px;
  outline: none;
  background: gray;
  color: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>